import { PrivacyPolicy } from "../types/working-model";
import { Get } from "./helpers";

export function GetPrivacyPolicy(privacy_policy: number): Promise<PrivacyPolicy> {
	return Get(`/v3/admin/events/privacy-policy/${privacy_policy}`, "");
}
